import { StatCardGrid } from '@/components/common/StatCardGrid';
import type { AppVersionCheckReport } from '../types/appVersionCheck.types';

type AppVersionTotals = Pick<
  AppVersionCheckReport,
  'totalDepartments' | 'totalAreaManagers' | 'totalMembers'
>;

interface AppVersionCheckSummaryProps {
  totals: AppVersionTotals | undefined;
}

export function AppVersionCheckSummary({ totals }: AppVersionCheckSummaryProps) {
  return (
    <StatCardGrid
      isLoading={totals === undefined}
      stats={[
        {
          key: 'departments',
          label: 'Departments',
          value: totals?.totalDepartments,
        },
        {
          key: 'areaManagers',
          label: 'Area Managers',
          value: totals?.totalAreaManagers,
        },
        {
          key: 'members',
          label: 'Members',
          value: totals?.totalMembers,
        },
      ]}
    />
  );
}
